import { component, prop, debounce } from '../../../decorators';

import FilterInput from '../filter-input/filter-input.vue';
import Tag from '../tag/tag.vue';
import MetadataInfo from '../metadata-info/metadata-info.vue';
import OpenerMixin from '../../../mixins/opener.mixin';
import PointerMixin from '../../../mixins/pointer.mixin';

import scrollIntoViewIfNeeded from '../../../helpers/dom/scrollIntoViewIfNeeded';

import keyBy from 'lodash/keyBy';
import reject from 'lodash/reject';
import has from 'lodash/has';
import includes from 'lodash/includes';
import values from 'lodash/values';
import first from 'lodash/first';

const SEARCH_DEBOUNCE = 300;

const MODES = { MULTIPLY: 'multiply', SINGLE: 'single' };
const ITEMS_POSITIONS = { ABSOLUTE: 'absolute', FIXED: 'fixed' };

const modeValidator = type => includes(values(MODES), type);
const positionValidator = type => includes(values(ITEMS_POSITIONS), type);

@component({
   components: { FilterInput, Tag, MetadataInfo },
   mixins: [ OpenerMixin, PointerMixin ],
   watch: {
      selected: 'onChangeSelected'
   }
})
export default class Lookup {
   @prop({ type: Array, required: true }) selected
   @prop({ type: Function, required: true }) load
   @prop({ type: Boolean, default: false }) disabled
   @prop({ type: String, default: MODES.MULTIPLY, validator: modeValidator }) mode
   @prop({ type: String, default: ITEMS_POSITIONS.ABSOLUTE, validator: positionValidator }) itemsPosition
   @prop({ type: Boolean, default: false }) autofocus

   text = ''
   list = []
   loading = false

   get isMultiplyMode() {
      return this.mode === MODES.MULTIPLY;
   }

   get isSingleMode() {
      return this.mode === MODES.SINGLE;
   }

   get isFixedItems() {
      return this.itemsPosition === ITEMS_POSITIONS.FIXED;
   }

   @debounce(SEARCH_DEBOUNCE)
   async onSearch(search) {
      if (this.text === search) {
         return;
      }
      this.text = search;
      this.loading = true;
      const list = await this.load(search);
      const cache = keyBy(this.selected, 'id');
      this.list = reject(list, i => has(cache, i.id));
      this.activate();
      this.$nextTick(this.repositionItemsIfNeeded);
      this.loading = false;
   }

   select(item) {
      this.deactivate();
      if ( this.isMultiplyMode ) {
         this.text = '';
         this.$emit('change', [ ...this.selected, item ]);
      } else {
         this.text = item.name; // TODO
         this.$emit('change', [ item ]);
      }
      this.list = [];
   }

   remove(item) {
      this.$emit('change', reject(this.selected, { id: item.id }) );
   }

   label(item) {
      return item.name;
   }

   onChangeSelected() {
      if ( this.isSingleMode ) {
         this.text = this.selected.length ? first(this.selected).name : '';
      }
   }

   repositionItemsIfNeeded() {
      const $list = this.$refs.list;
      if (!$list) {
         return;
      }

      if ( this.isFixedItems ) {
         const { left, right, bottom } = this.$el.getBoundingClientRect();
         $list.style.width = `${right - left}px`;
         $list.style.top = `${bottom}px`;
      } else {
         scrollIntoViewIfNeeded($list);
      }
   }

   deactivateIfNeeded(e) {
      if (this.isOpen && this.list.length) {
         this.deactivate();
         e.preventDefault();
         e.stopPropagation();
      }
   }

   created() {
      this.$on('expanded', () => this.repositionItemsIfNeeded);
   }
}
